
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface NavigationButtonsProps {
  currentQuestionIndex: number;
  questionsLength: number;
  hasSelectedOptions: boolean;
  onPrevQuestion: () => void;
  onNextQuestion: () => void;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentQuestionIndex,
  questionsLength,
  hasSelectedOptions,
  onPrevQuestion,
  onNextQuestion,
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <Button
        variant="outline"
        onClick={onPrevQuestion}
        disabled={currentQuestionIndex === 0}
      >
        <ChevronLeft className="h-4 w-4 mr-2" />
        Vorige
      </Button>
      <div className="text-sm text-center">
        {currentQuestionIndex + 1} van {questionsLength}
      </div>
      <Button
        variant={hasSelectedOptions ? "default" : "outline"}
        onClick={onNextQuestion}
        disabled={currentQuestionIndex >= questionsLength - 1}
        className={hasSelectedOptions ? "bg-primary shadow-md ring-2 ring-primary/30 transition-all" : ""}
      >
        Volgende
        <ChevronRight className="h-4 w-4 ml-2" />
      </Button>
    </div>
  );
};

export default NavigationButtons;
